import empty_table from '../../assets/images/empty_table.png';
import searchicon from '../../assets/images/search.png';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearMessage } from '../../slices/messages';
import { allAd } from '../../slices/advertisements';
import Pagination from '../dt/Pagination';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Advertisement = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { t, i18n } = useTranslation();

    const { allads } = useSelector((state) => state.advertisement);
    const { user } = useSelector((state) => state.auth);

    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';
    const [activeLang, setActiveLang] = useState(currentLang);

    const [currentPage, setCurrentPage] = useState(1);
    const [defaultSort, setSort] = useState({ 'sort_column': 'created_at', 'sort_type': 'desc' });
    const [search, setSearch] = useState("");

    let PageSize = 20;

    const changePageSize = (pageNumber) => {
        setSort({ 'sort_column': 'created_at', 'sort_type': 'desc' });
        setCurrentPage(pageNumber);
    }

    useEffect(() => {
        if(user && user.approve == "N") {
            navigate('/profile');
        }

        dispatch(clearMessage());

        let tmpVar = {
            page: currentPage,
            sort: defaultSort,
            activeLang: activeLang,
            search: search,
            status: '1'
        };

        dispatch(allAd(tmpVar));
    }, [defaultSort, currentPage, search]);

    const viewAds = (id) => {
        navigate('/advertisement/view/' + id);
    }

    return (
        <div className="container">
            <section className="mt-5 pt-5 gallery">
                <div className="row">
                    <div className='col-md-6'>
                        <div className='section-title' id='heading_title'>
                            <h1><span className='font-color-1'>{t('all_advertisements')}</span></h1>
                            <p>{t('approved_advrt')}</p>
                            <br />
                        </div>
                    </div>
                    <div className='col-md-6 table-search-area mt-2'>
                        <div className='table-search'>
                            <input type='search' className='form-control' placeholder={t('search_here')} onChange={e => setSearch(e.target.value)}/>
                            <img src={searchicon} />
                        </div>
                    </div>
                    {
                        allads != null && allads.total > 0 ?
                        allads?.res.map((item, index) => {
                                return (
                                    <div className="col-md-3 itemBox mb-4" onClick={() => viewAds(item.id)}>
                                        <div className="card">
                                            <div className="card-body p-0">
                                                <img src={item.image_path} class="mobile-img" width={260} height={205} />
                                            </div>
                                            <div className="card-footer">
                                                <h5 className='mb-0 text-center ads-title'>{item.title}</h5>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                            :
                            <div className='emptyTable'>
                                <img src={empty_table} />
                                <h5 className='mt-2-new'>{t('noData')}</h5>
                            </div>
                    }

                    <div className='col-md-12'>
                        <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            totalCount={allads ? allads.total : 1}
                            pageSize={PageSize}
                            onPageChange={page => changePageSize(page)}
                        />
                    </div>

                </div>
            </section>
        </div>
    );
}
export default Advertisement;